import { Typography, Stack, Box } from '@mui/material'
import CellRenderer from 'components/list/CellRenderer';

export const CellMobileDetails = ({ item, propsDetails }) => {
    const labelsx = { mr: '5px', fontWeight: 'bold', fontSize: '0.875rem' } // Reduced by 2px (from 1rem/16px to 14px)

    return (
        <Stack direction='row' sx={{ p: '8px!important', width: '100%', py: '8px!important' }}> {/* Decreased padding top and bottom */}
            <Stack direction='column' sx={{ width: '90%' }}>
                <Stack direction='row'>
                    <Typography variant="body" sx={labelsx}>{`Name: `}</Typography>
                    <CellRenderer type="name" item={item} events={propsDetails?.events} />
                </Stack>
                <Box>
                    <Typography variant="body" sx={labelsx}>{`Products: `}</Typography>
                    <CellRenderer type="text" item={item} field="products_count" />
                </Box>
                <Box>
                    <Typography variant="body" sx={labelsx}>{`Status: `}</Typography>
                    <Typography variant="body" sx={{ ...labelsx, color: item.is_active ? 'green' : 'red' }} >{item.is_active ? 'Active' : 'Inactive'}</Typography>
                </Box>
            </Stack>
            <Box sx={{ width: '10%' }}>
                <CellRenderer type="action" item={item} propsDetails={propsDetails} />
            </Box>
        </Stack>
    )
}

